import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EnvelopeIcon } from '@phosphor-icons/react'

import { Alert, ButtonWithSpinner, ChipInput, ComboBox, Text } from '@reveni-io/reveni-ui'

import { formats } from '@/common/constants'

import ExportInventorySelector from './ExportInventorySelector/ExportInventorySelector'
import ExportTemplateSelector from './ExportTemplateSelector/ExportTemplateSelector'
import { exportInventoryValues, maxExportEmails } from './constants'
import * as Styles from './styles'

const ExportInventorySection = ({
  exportEmails,
  onChangeExportEmails,
  exportTemplate,
  onChangeExportTemplate,
  exportFormat,
  onChangeExportFormat,
  onExportInventoryItems,
  exportedInventory,
  exportingInventory,
}) => {
  const { t } = useTranslation()
  const [exportInventoryOption, setExportInventoryOption] = useState(exportInventoryValues.existingCsv)

  const handleChangeExportFormat = event => onChangeExportFormat(event.target.value)

  return (
    <Styles.Container>
      <Text type="titleS">{t('Exportar inventario')}</Text>
      <ExportInventorySelector value={exportInventoryOption} onChange={setExportInventoryOption} />
      {exportInventoryOption === exportInventoryValues.exportCurrentInventory && (
        <>
          <ExportTemplateSelector value={exportTemplate} onChange={onChangeExportTemplate} />
          <ComboBox
            fullWidth
            handleChange={handleChangeExportFormat}
            menuItems={formats}
            label={t('Formato')}
            value={exportFormat}
          />
          <Text type="bodyMRegular">
            {t('Dirección de correo a la que enviar el fichero con el resultado de la exportación')}
          </Text>
          <ChipInput
            fullWidth
            label={t('Email')}
            helperText={t('Añade más direcciones de email separándolas por comas (,)')}
            Icon={EnvelopeIcon}
            value={exportEmails}
            onChange={onChangeExportEmails}
            maxChips={maxExportEmails}
          />
          <ButtonWithSpinner
            onClick={onExportInventoryItems}
            disabled={!exportEmails.length || exportingInventory}
            defaultLabel={t('Exportar')}
            loadingLabel={t('Exportando')}
            loading={exportingInventory}
          />
          {exportedInventory && (
            <Alert type="success">
              {t(
                '¡Solicitud enviada! Comprueba tu bandeja de entrada en unos momentos. Si no ves el correo electrónico, comprueba la carpeta de correo no deseado.'
              )}
            </Alert>
          )}
        </>
      )}
    </Styles.Container>
  )
}

export default ExportInventorySection
